import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { 
    Config,
    BOOLEAN_OPTIONS,
    Question,
} from '@ratehub/base-ui';

import { CoverageAmountValues } from '../definitions/CurrentDocument';
import CoverageAmountOptions from '../definitions/CoverageAmountOptions';
import QuestionStandardCity from './QuestionStandardCity';
import QuestionHasConsumedTobacco from './QuestionHasConsumedTobacco';
import QuestionWantsBundledQuote from './QuestionWantsBundledQuote';


function CoverageStandardQuestions({ values }) {
    return (
        <>
            {/* City */}
            <QuestionStandardCity
                city={values.city}
            />

            {/* Coverage amount */}
            <Question
                field={{
                    name: 'coverageAmount',
                    type: 'choice',
                    value: values.coverageAmount,
                    options: CoverageAmountOptions,
                }}
                labelMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageStandardQuestions.coverageAmount"
                        defaultMessage="How much coverage do you need?"
                    />
                )}
                tooltipMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageStandardQuestions.coverageAmountTooltip"
                        defaultMessage="While the exact amount of life insurance you need depends on your unique financial picture, approximately 10x your income is a good rule of thumb when determining life insurance coverage needs."
                    />
                )}
                type="radio" // Required to force 7+ options into radio
                shouldDisplayOptionsAsGrid
            />

            {/* Tobacco */}
            <QuestionHasConsumedTobacco
                value={values.hasConsumedTobacco}
            />

            {/* Joint policy */}
            <Question
                field={{
                    name: 'isJointPolicy',
                    type: 'boolean',
                    value: values.isJointPolicy,
                    options: BOOLEAN_OPTIONS,
                }}
                type="radio"
                labelMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageStandardQuestions.isJointPolicy"
                        defaultMessage="Would you like this to be a joint policy with a spouse or significant other?"
                    />
                )}
                tooltipMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageStandardQuestions.isJointPolicyTooltip"
                        defaultMessage="This is for a life insurance policy for two people – typically spouses or domestic partners – but it only pays out a benefit when one of them dies."
                    />
                )}
                shouldDisplayOptionsAsGrid
            />

            {/* Cleanup in INS-3191 */}
            <If condition={Config.ENABLE_INS_LIFE_BUNDLE_QUOTE_QUESTION}>
                {/* Free auto or home quote */}
                <QuestionWantsBundledQuote
                    value={values.wantsBundledQuote}
                />
            </If>
        </>
    );
}

CoverageStandardQuestions.propTypes = {
    values: PropTypes.shape({
        city: PropTypes.object,
        coverageAmount: PropTypes.oneOf(Object.values(CoverageAmountValues)),
        isJointPolicy: PropTypes.bool,
        hasConsumedTobacco: PropTypes.bool,
        wantsBundledQuote: PropTypes.bool,
    }).isRequired,
};


export default observer(CoverageStandardQuestions);
